import { Box } from '@chakra-ui/react';
import { TextRegular } from 'UiKit/typography';
import { useTooltip } from 'Store/tooltip';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const ARROW_OFFSET = 14;

const parseWidth = (width) => {
  if (typeof width === 'number') return width;
  if (typeof width === 'string') {
    const parsed = parseInt(width, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const Tooltip = () => {
  const { isOpenTooltip, label, position, childrenWidth, align, width, placement, htmlComponent } = useTooltip();

  let leftPosition = position?.x + childrenWidth / 2;
  const topPosition = position?.y;
  const widthNumber = parseWidth(width);

  if (placement === 'right') {
    leftPosition = position?.x + childrenWidth - widthNumber / 2 + ARROW_OFFSET;
  }

  if (placement === 'left') {
    leftPosition = position?.x + widthNumber / 2 - ARROW_OFFSET;
  }

  const isOpen = isOpenTooltip && (label || htmlComponent);

  return (
    <Condition statement={isOpen}>
      <Box className={`${styles['tooltip__container']} ${styles[`tooltip__container--${placement}`]}`} top={topPosition} left={leftPosition} width={width}>
        <Condition statement={!htmlComponent} fallback={<Box dangerouslySetInnerHTML={{ __html: htmlComponent }} />}>
          <TextRegular textAlign={align}>{label}</TextRegular>
        </Condition>
      </Box>
    </Condition>
  );
};

export default Tooltip;
